import React from 'react';
import AnalysisTablesShared from './AnalysisTablesShared';

export default function OrderFigureAnalysis() {
  return <AnalysisTablesShared mode="revenue" />;
}